// Fill in missing mappings using average
const fillAudioMap = (audioMap)=>{
  let previousMapping;
  return audioMap.reduce((finalMap, currentMapping)=>{
    if (previousMapping){
      const missingMappings = currentMapping.w - (previousMapping.w + 1);
      if (missingMappings > 0){
        const timeDifference = currentMapping.t - previousMapping.t;
        const avgTime = timeDifference / (missingMappings + 1);
        for (let i = 1; i <= missingMappings; i++){
          finalMap.push({
            t: previousMapping.t + (avgTime * i),
            w: previousMapping.w + i,
            // generated: true
          })
        }
      }
    }
    previousMapping = currentMapping;
    return finalMap.concat([currentMapping]);
  }, [])
}

// Adjust mapping to be halfway between words
const adjustAudioMapTimings = (audioMap, speed)=>{
  let previousMapping;
  let lastIndex = audioMap.findLastIndex(() => true)
  let modifiedAudioMap = [...audioMap, audioMap[lastIndex]];
  let finalAudioMap =  modifiedAudioMap.reduce((finalMap, currentMapping)=>{
    let newCurrentMapping;
    if (previousMapping){
      newCurrentMapping = {
        ...currentMapping,
        t:  Math.max(previousMapping.t + ((currentMapping.t - previousMapping.t)/Math.max(speed, 2)), currentMapping.t - 1) - 0.2
      }
    } else {
      newCurrentMapping = currentMapping;
    }
    previousMapping = currentMapping;
    return finalMap.concat([newCurrentMapping]);
  }, [])
  finalAudioMap.shift();
  let lastObject = finalAudioMap[lastIndex];
  lastObject.w = lastObject.w + 1;
  return finalAudioMap;
}

export const adjustAudioMap = (audioMap, speed)=>{
  const filledAudioMap = fillAudioMap(audioMap);
  return adjustAudioMapTimings(filledAudioMap, speed);
}


export const getCurrentHighlight = (audioMap, currentTime)=>{
  let i = 0;
  while (i < audioMap.length){
    const { t, w } = audioMap[i++];
    const nextT = (audioMap[i] && audioMap[i].t) || Number.MAX_SAFE_INTEGER;
    if (currentTime > t && currentTime < nextT){
      return w;
    }
  }
  return -2;
}
